"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationsContext = void 0;
var React = __importStar(require("react"));
var validator_1 = __importDefault(require("./validator"));
exports.ValidationsContext = React.createContext({});
var ValidationsContextProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState({}), formFields = _b[0], setFormFields = _b[1];
    var _c = React.useState(false), submitted = _c[0], setSubmitted = _c[1];
    var _d = React.useState({}), textValidation = _d[0], setTextValidation = _d[1];
    var validateField = function (name, fieldValidate) {
        var error = (0, validator_1.default)(fieldValidate.validation, fieldValidate.value);
        setFormFields(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), (_a = {},
                _a[name] = __assign(__assign({}, fieldValidate), { error: error }),
                _a));
        });
    };
    var value = {
        submitted: submitted,
        setSubmitted: setSubmitted,
        formFields: formFields,
        validateField: validateField,
        textValidation: textValidation,
        setTextValidation: setTextValidation,
    };
    return (React.createElement(exports.ValidationsContext.Provider, { value: value }, children));
};
exports.default = ValidationsContextProvider;
//# sourceMappingURL=FormContext.js.map